import { Helmet } from 'react-helmet';
import { Transcation } from 'src/components/Transcation';

const TranscationPage = () => (
  <>
    <Helmet>
      <title> Transcations</title>
    </Helmet>

    <Transcation />
  </>
);

export default TranscationPage;
